import React from 'react';
// import { Route } from 'react-router-dom';

// components
import UsaChromeShell from './components/UsaChromeShell';
import Main from './components/Main';

function App() {
  return (
    <UsaChromeShell>
      <Main />
    </UsaChromeShell>
  );
}

export default App;